import React from 'react';
import {
  AlignCenter,
  AlignLeft,
  AlignRight,
  Calendar,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Copy,
  Eye,
  GalleryHorizontalEnd,
  Globe,
  HelpCircle,
  Image as ImageGlyph,
  Library,
  LucideIcon,
  Moon,
  MoreVertical,
  MousePointerClick,
  Plus,
  Redo2,
  RotateCw,
  Settings,
  Shapes,
  Smartphone,
  Sparkles,
  Sun,
  Trash2,
  Type,
  Undo2,
  Upload,
  Users,
  X,
  Zap,
} from 'lucide-react';

import { TIconProps } from './Icons.types';

const icon =
  (Glyph: LucideIcon) =>
  ({ size = 20, color, className, strokeWidth = 1.8 }: TIconProps) => (
    <Glyph size={size} color={color} className={className} strokeWidth={strokeWidth} aria-hidden />
  );

export const SparkleIcon = icon(Sparkles);
export const TextIcon = icon(Type);
export const CtaIcon = icon(MousePointerClick);
export const InteractiveIcon = icon(Zap);
export const MediaIcon = icon(ImageGlyph);
export const ElementIcon = icon(Shapes);
export const AssetsIcon = icon(Library);
export const HelpIcon = icon(HelpCircle);
export const UploadIcon = icon(Upload);
export const StoriesIcon = icon(GalleryHorizontalEnd);
export const UsersIcon = icon(Users);
export const SettingsIcon = icon(Settings);
export const CalendarIcon = icon(Calendar);
export const GlobeIcon = icon(Globe);
export const UndoIcon = icon(Undo2);
export const RedoIcon = icon(Redo2);
export const RotateIcon = icon(RotateCw);
export const DeviceMobileIcon = icon(Smartphone);
export const EyeIcon = icon(Eye);
export const CopyIcon = icon(Copy);
export const MoreVerticalIcon = icon(MoreVertical);
export const TrashIcon = icon(Trash2);
export const PlusIcon = icon(Plus);
export const ChevronDownIcon = icon(ChevronDown);
export const ChevronUpIcon = icon(ChevronUp);
export const ChevronLeftIcon = icon(ChevronLeft);
export const ChevronRightIcon = icon(ChevronRight);
export const CloseIcon = icon(X);
export const AlignLeftIcon = icon(AlignLeft);
export const AlignCenterIcon = icon(AlignCenter);
export const AlignRightIcon = icon(AlignRight);
export const SunIcon = icon(Sun);
export const MoonIcon = icon(Moon);
